var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlurHeaderLandinginline = function SvgBlurHeaderLandinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 502,
    fill: "none",
    viewBox: "0 0 1455 502"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur-header-landing_inline_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#blur-header-landing_inline_svg__b)",
    d: "M1567-404.136C1567-12.088 1172.41 476 712.356 476 252.303 476-99-12.089-99-404.136-99-796.183 273.947-1114 734-1114c460.05 0 833 317.817 833 709.864Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blur-header-landing_inline_svg__b",
    x1: -114.619,
    x2: 1567.24,
    y1: -472.527,
    y2: -459.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#00A98F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur-header-landing_inline_svg__a",
    width: 1718,
    height: 1642,
    x: -125,
    y: -1140,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_269_2919",
    stdDeviation: 13
  })))));
};
export default SvgBlurHeaderLandinginline;